<template>
  <div class="flex flex-col gap-y-3">
    <div class="flex items-center justify-between border-b border-brand-gray-350 w-full mb-4">
      <div class="pb-2 w-full">
        <h2 class="text-xl text-gray-700 font-normal mx-3">
          {{ $t('hotelQouta') }}
        </h2>
      </div>
    </div>
    <DataTable
      :default-headers="['description', 'establishmentNumber', 'actualQuota', 'remainingQuota']"
      :rows="delegateInfo"
    >
    </DataTable>
    <template v-if="!isLoading && dataSet.length > 5">
      <div
        class="py-2 w-full flex flex-col md:flex-row gap-y-4 items-center justify-center md:justify-between"
      >
        <div class="w-56 flex border border-brand-gray-300 rounded-md">
          <button
            :key="pc"
            v-for="pc in pageCounts"
            :class="{ 'bg-primary text-white': paginatorConfig.itemsPerPage == pc }"
            class="flex-1 p-1 border-e first:rounded-s-md last:rounded-e-md last:border-none border-brand-gray-300 hover:bg-primary/70"
            @click="onPageCountChange(pc)"
          >
            {{ pc }}
          </button>
        </div>
        <Paginate
          :page-count="paginatorConfig.pageCount"
          :page-range="paginatorConfig.itemsPerPage"
          :click-handler="onPageClick"
          :prev-text="'‹'"
          :next-text="'›'"
          :first-last-button="true"
          v-model="paginatorConfig.currentPage"
          container-class="pagination"
          first-button-text="«"
          last-button-text="»"
          class="accent-primary-700"
        />
        <div class="w-56 flex justify-center md:justify-end items-center gap-x-2">
          <input
            type="text"
            class="w-full max-w-[4ch] py-1.5 rounded-md border border-brand-gray-600 outline-none text-center focus:border-primary"
            v-model.number="paginatorConfig.currentPage"
            @input="onOverridePage(paginatorConfig.currentPage)"
          />
          <span class="">{{ $t('of') }} {{ paginatorConfig.pageCount }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import axiosInstance from '@/services'
import { onMounted, ref, computed, reactive } from 'vue'
import DataTable from '@/components/DataTable/index.vue'
import Paginate from 'vuejs-paginate-next'

const quota = ref()
const isLoading = ref(true)

const pageCounts = [5, 10, 20, 50, 100]

const searchCriteria = reactive({
  currentPage: 1,
  pageSize: 10
})

const paginatorConfig = reactive({
  totalItemCount: 0,
  itemsPerPage: 10,
  currentPage: 1,
  pageCount: 0
})

const dataSet = computed(() => {
  if ((quota.value || []).length === 0) {
    return null
  }

  return quota.value.map((q) => {
    return {
      description: q.description,
      establishmentNumber: q.estabNumber,
      actualQuota: q.actualQuota,
      remainingQuota: q.remainingQuota
    }
  })
})

onMounted(async () => {
  await fetchQuota()
})

async function fetchQuota() {
  const body = {
    ...searchCriteria
  }

  const response = await axiosInstance.post('/api/establishment/hotel/quotes', body)

  if (!response || (Array.isArray(response) && response.length === 0) || !response?.collection)
    return

  quota.value = response.collection

  const [firstRow] = response.collection

  const { totalRecords } = firstRow

  paginatorConfig.totalItemCount = totalRecords
  paginatorConfig.pageCount = Math.ceil((totalRecords || 1) / paginatorConfig.itemsPerPage)
  isLoading.value = false
}
</script>

<style lang="scss" scoped></style>
